export default __webpack_public_path__ + "static/media/polly-flap-squawk-animation.103871f6.svg";